import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  root: {
    padding: theme.spacing(5),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3, 2),
      marginBottom: theme.spacing(2),
    },
  },
  header: {
    marginBottom: theme.spacing(5),
  },
}));

export default useStyles;
